import type { ForqSupabaseClient } from './client';
import { normalizeCompanyProfile, type CompanyProfileGateway, type TenantCompanyProfile } from '@forq/platform-data';
import { SupabaseOperationError } from './errors';

function messageOf(error: { readonly message: string } | null): string {
  return error?.message ?? 'Unknown Supabase error.';
}

/**
 * Firmenprofil (Grundkonfiguration) gegen Supabase -- ersetzt die localStorage-Variante, damit der
 * Briefkopf geräteübergreifend und für alle Mitarbeiter des Mandanten gilt.
 *
 * Gespeichert als ein jsonb je Mandant (inkl. der Logo-Data-URIs). LESEN kann jedes Mandantenmitglied
 * (die Belege brauchen den Briefkopf), SPEICHERN nur die Verwaltung -- das trennen die beiden RPCs.
 * normalizeCompanyProfile füllt beim Laden/Speichern fehlende Felder auf (Vorwärtskompatibilität).
 */
export class SupabaseCompanyProfileGateway implements CompanyProfileGateway {
  constructor(private readonly client: ForqSupabaseClient) {}

  async loadProfile(tenantId: string): Promise<TenantCompanyProfile> {
    const { data, error } = await this.client.rpc('company_profile_get', { p_tenant_id: tenantId });
    if (error) throw new SupabaseOperationError('company.company_profile_get', messageOf(error));
    return normalizeCompanyProfile(data ?? {});
  }

  async saveProfile(tenantId: string, profile: TenantCompanyProfile): Promise<TenantCompanyProfile> {
    const normalized = normalizeCompanyProfile(profile);
    const { error } = await this.client.rpc('company_profile_save', { p_tenant_id: tenantId, p_profile: normalized });
    if (error) throw new SupabaseOperationError('company.company_profile_save', messageOf(error));
    return normalized;
  }
}
